import { yupEmail } from "@/components/yup-utils";
import { object } from "yup";

const emailValidationMessage =
  'Please enter a valid email address (e.g. "user@example.com")';

export const emailCollectionSchema = object().shape({
  email: yupEmail().required(emailValidationMessage),
});
